// Module
var code = "<div class=\"users-tab\">\r\n    <dual-list-box params=\"unwrappedProps: usersTabProps.vueComponentProps\">\r\n</div>";
// Exports
export default code;